export default {
    methods: {
        requestMemberLogin(continueAction) {
            const targetPath = this.$route.fullPath;
            this._storeData('LoginFUN', () => {
                if (this.$route.fullPath === targetPath) continueAction();
                else this.$router.push(targetPath).then(continueAction);
                this._storeData('LoginFUN', '');
            });
            const openLogin = this._storeData('LoginF1');
            if (this.IsNull(openLogin) !== '') openLogin();
            else this.$root.$emit('bv::show::modal', 'signin');
        },
    },
};
